import axios from "axios";

const API_BASE = "/api/leaves";

export const getLeavesForAdmin = async () => {
  try {
    const res = await axios.get(`${API_BASE}/admin`);
    return res.data;
  } catch (error) {
    console.error("Error fetching leaves for admin:", error);
    throw error;
  }
};

export const getLeavesForTeacher = async (id) => {
  try {
    const res = await axios.get(`${API_BASE}/teacher/${id}`);
    return res.data;
  } catch (error) {
    console.error("Error fetching leaves for teacher:", error);
    throw error;
  }
};

// Student के लिए नया function जोड़ें
export const getLeavesForStudent = async (id) => {
  try {
    const res = await axios.get(`${API_BASE}/student/${id}`);
    return res.data;
  } catch (error) {
    console.error("Error fetching leaves for student:", error);
    throw error;
  }
};

// User के लिए general function जोड़ें
export const getLeavesForUser = async (id, role) => {
  try {
    // Role के आधार पर अलग endpoint call करें
    if (role === 'teacher') {
      return await getLeavesForTeacher(id);
    } else if (role === 'student') {
      return await getLeavesForStudent(id);
    } else {
      // Default: teacher की तरह handle करें
      return await getLeavesForTeacher(id);
    }
  } catch (error) {
    console.error(`Error fetching leaves for user ${id} (role: ${role}):`, error);
    throw error;
  }
};

export const getParentChildren = async (id) => {
  try {
    const res = await axios.get(`${API_BASE}/parent/${id}`);
    return res.data;
  } catch (error) {
    console.error("Error fetching parent children:", error);
    throw error;
  }
};

export const createLeave = async (payload) => {
  try {
    const res = await axios.post(API_BASE, payload);
    return res.data;
  } catch (error) {
    console.error("Error creating leave:", error);
    throw error;
  }
};

export const updateLeave = async (id, payload) => {
  try {
    const res = await axios.put(`${API_BASE}/${id}`, payload);
    return res.data;
  } catch (error) {
    console.error("Error updating leave:", error);
    throw error;
  }
};

export const deleteLeave = async (id) => {
  try {
    const res = await axios.delete(`${API_BASE}/${id}`);
    return res.data;
  } catch (error) {
    console.error("Error deleting leave:", error);
    throw error;
  }
};

export const updateLeaveStatus = async (id, payload) => {
  try {
    console.log(`Updating leave ${id} status to ${payload.status}`);
    const res = await axios.put(`${API_BASE}/${id}/status`, payload);
    return res.data;
  } catch (error) {
    console.error("Error updating leave status:", error);
    throw error;
  }
};

// Get all leaves (for testing)
export const getLeaves = async () => {
  try {
    const res = await axios.get(API_BASE);
    return res.data;
  } catch (error) {
    console.error("Error fetching leaves:", error);
    throw error;
  }
};

// Get leave by ID (for testing)
export const getLeaveById = async (id) => {
  try {
    const res = await axios.get(`${API_BASE}/${id}`);
    return res.data;
  } catch (error) {
    console.error("Error fetching leave by ID:", error);
    throw error;
  }
};